export { H as HEADER_CONTENT_DEFAULT, c as HEADER_CONTENT_LANDING_PAGE, d as HEADER_ICON_LINK_TYPE_MULTIPLE, e as HEADER_ICON_LINK_TYPE_SINGLE, f as HEADER_ICON_NOTIFICATION, g as HEADER_ICON_SEARCH, h as HEADER_ICON_SHARE, i as HEADER_ICON_SHORTLIST, j as HEADER_LAYOUT_APP, k as HEADER_LAYOUT_SITE, l as HEADER_TITLE_LOGO, m as HEADER_TITLE_TEXT, P as PageHeader } from '../../../chunks/component-CXDLrjgS.js';
import 'react/jsx-runtime';
import '@sgcmpteltd/uikit-react';
import '@sgcmpteltd/uikit-react/hooks';
import '@sgcmpteltd/uikit-react/utils/position/absolute';
import '@sgcmpteltd/uikit-react/utils/string';
import 'clsx';
import 'react';
import '../../../chunks/component-BlaoJfVJ.js';
import '../../../chunks/style-inject.es-Bff-fD1R.js';
import '../../../chunks/component-D5qJ4zZ9.js';
import '../../../utils/navigator/index.js';
//# sourceMappingURL=index.js.map
